import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import Icon from 'flarum/common/components/Icon';
export default function () {
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const views = this.attrs.discussion.views();
    items.add('discussion-views', m("span", null, m(Icon, {
      name: "far fa-eye"
    }), " ", abbreviateNumber(views)));
  });
}